exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.type-label[data-v-0a2230d7] {\n\tcolor: #4C9850;\n\tdisplay:block;\n\tfont-weight: 400;\n\tfont-size: 1em;\n\ttext-transform:uppercase;\n}\n.group-title-wrapper[data-v-0a2230d7] {\n\twidth:100%;\n}\nh1[data-v-0a2230d7] {\n\tfont-size:22px;\n}\nh1.edit-d-title[data-v-0a2230d7]::after {\n\tbackground:transparent;\n\tright:-40px;\n}\ntextarea.title-field[data-v-0a2230d7] {\n\tfont-size:22px;\n}\n", ""]);

// exports
